<template>
  <article class="quiz-item">
    <div class="quiz-notice container-sm" v-if="!isClassStudent">
      {{ $t('viewer.quiz_item.alerts.quiz_preview') }}
    </div>

    <lc-audio
      :audio="audio"
      :key="audio.id"
      v-for="audio in quiz.audios"
    />

    <header class="quiz-header container-sm">
      <span class="quiz-position">
        <span class="quiz-position__label">
          {{ $t('viewer.quiz.header.label', { pageNumber }) }}
        </span>
      </span>
      <span class="quiz-type">
        <span class="quiz-type__label">{{ $t(pageTypeName) }}</span>
      </span>
      <ReportContent
        v-if="isStoreCard"
        :card="card"
        :page="currentPage"
        :selectedOption="selectedOptionIndex"
        :answerOption="correctOptionIndex"
        :enteredValue="quizAnswerValue"
        :answerValue="correctAnswerContents"
        :quizSolved="quizSolved"
        :isCorrect="quizResult && quizResult.is_correct"
      />
    </header>

    <content-viewer :page="quiz" :content="quiz.content" />

    <template v-if="pageType === 'multiple_choice' && quiz.answer_view_type === 'control'">
      <options
        :options="quiz.answers"
        v-if="!isOptionsBlank"
      />

      <options-control
        :quiz="quiz"
        v-show="!quizSolved"
      />
    </template>

    <options-list-control
      :quiz="quiz"
      v-if="pageType === 'multiple_choice' && quiz.answer_view_type === 'list'"
    />

    <text-entry-control v-if="pageType === 'text_entry' && !quizSolved" :quiz="quiz" />

    <essay-type-control v-if="pageType === 'essay_type' && !quizSolved" :quiz="quiz" />

    <quiz-result
      :quiz="quiz"
      :page-type="pageType"
      v-if="quizSolved"
    />

    <quiz-description
      :quiz="quiz"
      :content="quiz.description"
      ref="quizDescription"
      v-if="quizSolved && quizResult.is_graded"
    />

  </article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';

import ContentViewer from '../components/ContentViewer';
import LcAudio from '../components/LcAudio';
import QuizDescription from '../components/QuizDescription';
import QuizResult from '../components/QuizResult';
import Options from '../components/Options';
import OptionsControl from '../components/OptionsControl';
import OptionsListControl from '../components/OptionsListControl';
import TextEntryControl from '../components/TextEntryControl';
import EssayTypeControl from '../components/EssayTypeControl';

export default {
  name: 'quiz-item',

  props: [
    'quiz',
  ],

  data() {
    return {
      isShowContentReportSuccessModal: false,
      isShowContentReportModal: false,
      isShowConfirmContentReportModal: false,
    };
  },

  components: {
    ContentViewer,
    LcAudio,
    QuizDescription,
    QuizResult,
    Options,
    OptionsControl,
    OptionsListControl,
    TextEntryControl,
    EssayTypeControl,
  },

  computed: {
    ...mapGetters({
      busy: 'getBusy',
      routeParams: 'getRouteParams',
      cardId: 'getCardId',
      quizSolved: 'getQuizSolved',
      isOptionsBlank: 'getIsOptionsBlank',
      quizResult: 'getQuizResult',
      pageTypes: 'pageTypes',
      card: 'getCard',
      currentPage: 'getPage',
      pageNumber: 'getPageNumber',
      isClassStudent: 'isClassStudent',
      selectedOptionIndex: 'getSelectedOptionIndex',
      correctOptionIndex: 'getCorrectOptionIndex',
      quizAnswerValue: 'getQuizAnswerValue',
      correctAnswerContents: 'getCorrectAnswerContents',
      savedQuizOptions: 'getSavedQuizOptions',
      savedQuizValue: 'getSavedQuizValue',
    }),

    pageTypeName() {
      return this.pageTypes[this.quiz.page_type.name];
    },

    pageType() {
      if (this.quiz && this.quiz.page_type) {
        return this.quiz.page_type.name;
      }

      if (this.quiz && this.quiz.page_type_id === 2) {
        return 'multiple_choice';
      }

      if (this.quiz && this.quiz.page_type_id === 3) {
        return 'text_entry';
      }

      if (this.quiz && this.quiz.page_type_id === 4) {
        return 'essay_type';
      }

      return '';
    },

    assignedCard() {
      if (!isNil(this.card)) {
        return this.card.assigned_card;
      }

      return null;
    },

    isStoreCard() {
      if (!isNil(this.assignedCard)) {
        return !isNil(this.assignedCard.store_card_id);
      }

      return null;
    },

  },

  methods: {
    ...mapActions({
      fetchQuizResults: 'fetchQuizResults',
      resetSelectedOptions: 'resetSelectedOptions',
      resetEnteredValue: 'resetEnteredValue',
    }),

    handleContentReportOpenClick() {
      this.isShowConfirmContentReportModal = true;
    },

    handleConfirmContentReportClick() {
      this.isShowContentReportModal = true;
      this.isShowConfirmContentReportModal = false;
    },

    handleContentReportSent() {
      this.isShowContentReportModal = false;
      this.isShowContentReportSuccessModal = true;
    },

  },

  beforeMount() {
    if (isEmpty(this.savedQuizOptions)) {
      this.resetSelectedOptions();
    }

    if (isEmpty(this.savedQuizValue)) {
      this.resetEnteredValue();
    }
  },
};
</script>

<style lang="scss" scoped>
  .quiz-item {
    .quiz-notice {
      padding: 14px 14px 0 14px;
      color:#00c896;
      font-weight: bold;
    }

    .quiz-header {
      padding-top: 18px;
      padding-bottom: 8px;
    }

    .quiz-result-cover-visible {
      filter: blur(2px);
    }

    .quiz-position {
      .quiz-position__label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.54);
      }
    }

    .quiz-type {

      .quiz-type__label {
        margin: 0 0 0 8px;
        font-size: 14px;
        color: #808080;
      }
    }
  }
</style>
